(function () {
  'use strict';
  if (window.GMSSetQuickAddBound) return;
  window.GMSSetQuickAddBound = true;
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  function updateCartCount(count) {
    var link = document.querySelector('#cart-icon-bubble');
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');
    if (count <= 0) { if (bubble) bubble.remove(); return; }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      link.appendChild(bubble);
    }
    var visible = bubble.querySelector('span[aria-hidden="true"]');
    var hidden = bubble.querySelector('.visually-hidden');
    if (visible) visible.textContent = count < 100 ? count : '99+';
    if (hidden) hidden.textContent = count + '個の商品がカゴに入っています';
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-gms-set-quickadd]');
    if (!button || button.disabled || button.dataset.busy === 'true') return;
    var variantId = Number(button.dataset.variantId);
    var wrapper = button.closest('[data-gms-set-card]');
    var status = wrapper ? wrapper.querySelector('[data-gms-set-quick-status]') : null;
    var label = button.dataset.itemLabel || 'セット商品';
    if (!Number.isSafeInteger(variantId) || variantId <= 0) {
      if (status) status.textContent = 'この商品は現在カゴに追加できません。';
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    button.dataset.busy = 'true';
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'カゴに追加中…';
    var gmsAddedConfirmed = false;
    try {
      var sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (section) { return section.id; })
        : ['cart-icon-bubble'];
      if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
      var addResponse = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      });
      var added = await addResponse.json();
      if (!addResponse.ok || added.status) {
        throw new Error(added.description || added.message || 'カゴに追加できませんでした。');
      }
      gmsAddedConfirmed = true;
      if (drawer && added.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(added);
      }
      var cartResponse = await fetch(root + 'cart.js', {headers: {'Accept': 'application/json'}});
      if (!cartResponse.ok) throw new Error('カートの状態を確認できませんでした。');
      var cart = await cartResponse.json();
      if (!cart.items || !cart.items.some(function(item){ return String(item.id) === String(variantId); })) { window.location.assign(root + 'cart'); return; }
      if (!drawer) updateCartCount(cart.item_count || 0);
      if (status) status.textContent = label + 'をカゴに追加しました ✓';
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: cart}}));
    } catch (error) {
      if (gmsAddedConfirmed) { window.location.assign(root + 'cart'); return; }
      if (status) status.textContent = error && error.message ? error.message : '追加状況を確認できませんでした。カートをご確認ください。';
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.dataset.busy = 'false';
    }
  });
})();
